import React from "react";
import { CardMedia } from "../card/CardMedia";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { WorkoutExerciseImage } from "./types";
import { getCloudFlareSources, isVideoStream } from "../../utils/component";
import ReactPlayer from "react-player";
import { WorkoutDemoVideoPreview } from "./WorkoutDemoVideoPreview";
import { WorkoutVideoDemoWithThumbnail } from "../admin/WorkoutVideoDemoWithThumbnail";

export type WorkoutCardMediaProps = {
  coverImage?: boolean | undefined;
  coverImageIndex?: number;
  handleMediaClick?: (e) => void;
  classNameContainer: string;
  coverImageUrl: string;
  classNameCoverImage: string;
  hasImages: boolean;
  images: WorkoutExerciseImage[];
  classNameHasImagesContainer: string;
  classNameHasImagesImage: string;
  video?: any;
  videoClassName: string;
};

const WorkoutCardMedia = (props: WorkoutCardMediaProps) => {
  const {
    coverImage,
    coverImageIndex,
    handleMediaClick,
    coverImageUrl,
    hasImages,
    images,
    classNameContainer,
    classNameCoverImage,
    classNameHasImagesContainer,
    classNameHasImagesImage,
    video,
    videoClassName,
  } = props;

  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <div className={classNameContainer}>
      {coverImage && !video && (
        <CardMedia
          data-media-index={coverImageIndex}
          onClick={handleMediaClick}
          fit={false}
          className={classNameCoverImage}
          image={coverImageUrl}
        />
      )}
      {video && (
        // Set the height and width manually to ensure proper scaling.
        // Without this, the video may overflow or break layout(during Joyride journey).
        <WorkoutVideoDemoWithThumbnail
          className={videoClassName}
          youtubeQuality={"sddefault"}
          video={video}
          width="100%"
          height={isMdDown ? 420 : 240}
        />
      )}
      {hasImages && (
        <Box className={classNameHasImagesContainer}>
          {images.map((image, index) =>
            video ? (
              <CardMedia
                key={index}
                data-media-index={index}
                fit={false}
                data-collapsed="hidden"
                onClick={handleMediaClick}
                className={classNameHasImagesImage}
                image={image.url}
              />
            ) : (
              index !== coverImageIndex && (
                <CardMedia
                  key={index}
                  data-media-index={index}
                  fit={false}
                  data-collapsed="hidden"
                  onClick={handleMediaClick}
                  className={classNameHasImagesImage}
                  image={image.url}
                />
              )
            ),
          )}
        </Box>
      )}
    </div>
  );
};

export default WorkoutCardMedia;
